import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Chart from "react-google-charts";

function EventsStaffStatsResourcesShared(props) {
  const data = props.data;
  const [sharedInfo, setSharedInfo] = useState(false);
  const staffData =  [['Department', 'Staff']];
  const hoursData =  [['Department', 'Hours']];
  const costData =  [['Department', 'Cost']];

  data && data.forEach((element) => {
    staffData.push(
      [element.department_name, parseInt(element.staff)]
    );
    hoursData.push(
      [element.department_name, parseFloat(element.hours)]
    );
    costData.push(
      [element.department_name, parseFloat(element.cost)]
    );
  });

  return (
    <>
      <button className="btn btn-shared-resources" type="button"
        onClick={() => setSharedInfo(true)}>
        <i className="fas fa-plane" title="Shared Resources"></i>
      </button>
      <Modal show={sharedInfo} onHide={() => setSharedInfo(false)} className="modal-shared" size="xl">
        <Modal.Header>
          <Modal.Title>
            <i className="fas fa-plane"></i>&nbsp;
            Shared Resources Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col">
            <h6>Members Staffed by Department</h6>
            <Chart
              chartType="PieChart"
              loader={<div>Loading</div>}
              data={staffData}
              options={{
                backgroundColor: 'transparent',
                width: '300',
                height: 200
              }}
            />
            <Chart
              chartType="Table"
              loader={<div>Loading</div>}
              data={staffData}
              options={{
                  width: '100%'
              }}
            />
          </div>
          <div className="col">
            <h6>Hours by Department</h6>
            <Chart
              chartType="PieChart"
              loader={<div>Loading</div>}
              data={hoursData}
              options={{
                backgroundColor: 'transparent',
                width: '300',
                height: 200
              }}
            />
            <Chart
              chartType="Table"
              loader={<div>Loading</div>}
              data={hoursData}
              options={{
                  width: '100%'
              }}
            />
          </div>
          <div className="col">
            <h6>Cost by Department</h6>
            <Chart
              chartType="PieChart"
              loader={<div>Loading</div>}
              data={costData}
              options={{
                backgroundColor: 'transparent',
                width: '300',
                height: 200
              }}
            />
            <Chart
              chartType="Table"
              loader={<div>Loading</div>}
              data={costData}
              options={{
                  width: '100%'
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setSharedInfo(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default EventsStaffStatsResourcesShared
